const formLabelFormCreateUser = {
  text: 'Type of Access'
};

export default formLabelFormCreateUser;
